<template>
  <a-tabs v-model:activeKey="searchForm.status" style="background-color: #fff; padding: 0 12px" @change="getTableData()">
    <a-tab-pane key="0" tab="全部"></a-tab-pane>
    <a-tab-pane key="1" tab="待处理"></a-tab-pane>
    <a-tab-pane key="2" tab="已确认"></a-tab-pane>
    <a-tab-pane key="3" tab="已处理"></a-tab-pane>
    <a-tab-pane key="4" tab="已关闭"></a-tab-pane>
  </a-tabs>

  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-group">
          <div class="group-one">
            <a-input v-model:value="searchForm.order_id" :loading="searchLoading" allowClear placeholder="订单ID" @search="getTableData"></a-input>
          </div>
          <div class="group-one">
            <a-input v-model:value="searchForm.user_id" :loading="searchLoading" allowClear placeholder="用户ID" @search="getTableData"></a-input>
          </div>
          <div class="group-one">
            <a-input v-model:value="searchForm.hid" :loading="searchLoading" allowClear placeholder="房间ID" @search="getTableData"></a-input>
          </div>
        </div>
        <div class="lef-one">
          <a-input-search v-model:value="searchForm.keyword" :loading="searchLoading" placeholder="房间名称/订单号" @search="getTableData"></a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="searchLoading"
      :pagination="false"
      :scroll="{ x: columns.length > 12 ? 2500 : 0, y: tableHeight }"
      bordered
      class="table"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'order_no'">
          <a-button
            type="link"
            @click="
              detShow = true;
              orderId = record.order_id;
            "
            >{{ record.order_no }}
          </a-button>
        </template>
        <template v-if="column.key == 'hname'">
          <div>{{ record.hid }}</div>
          <div>{{ record.hname }}</div>
        </template>
        <template v-if="column.key == 'user_id'">
          <div>{{ record.user_id }}</div>
          <div>{{ record.nickname }}</div>
        </template>
        <template v-if="column.key == 'images'">
          <a-image-preview-group class="image-preview-group">
            <a-image v-for="(item, index) in record.images" :key="index" :src="item.url" :width="30" />
          </a-image-preview-group>
        </template>
        <template v-if="column.key == 'operate'">
          <a-button
            type="link"
            @click="
              feedShow = true;
              id = record.id;
            "
            >查看
          </a-button>
        </template>
      </template>
    </a-table>

    <!-- 分页 -->
    <MyPagination :pageTotal="pageTotal" @onShowSizeChange="onShowSizeChange" @pageChange="pageChange" />

    <!-- 订单详情 -->
    <order-details v-model:visible="detShow" :orderId="orderId" @refreshOrderDetails="refresh" />

    <!-- 意见详情 -->
    <FeedbackDetails :id="id" v-model:visible="feedShow" @refresh="getTableData"></FeedbackDetails>
  </div>
</template>

<script>
import OrderDetails from '@/components/pms/landlord/OrderDetails/OrderDetails.vue';
import FeedbackDetails from '../../../../components/pms/landlord/feedback/Details.vue';
import { nextTick, onMounted, reactive, toRefs, watch } from 'vue';
import { feedBackList } from '@/api/api';
import useUtils from '@/hooks/useUtils.js'; //工具库
import store from '@/store/pms/landlord/index';

export default {
  components: {
    FeedbackDetails,
    OrderDetails,
  },
  setup() {
    let { countTable } = useUtils();

    // 搜索
    const search = reactive({
      topDom: '',
      searchLoading: false,
      searchForm: {
        status: 0,
        keyword: '',
        start: 0,
        limit: 20,
        order_id: '',
        hid: '',
        user_id: '',
      },
      rangePicker: [],
      visiblePopover: false,
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
      },
      handleReset() {
        search.searchForm.order_id = '';
        search.searchForm.keyword = '';
        search.searchForm.user_id = '';
        search.searchForm.hid = '';
        table.getTableData();
      },
    });

    function getColumns() {
      return [
        {
          title: '记录ID',
          dataIndex: 'id',
          key: 'id',
          isShow: true,
          width: 80,
        },
        {
          title: '订单号',
          dataIndex: 'order_no',
          key: 'order_no',
          min_width: 120,
          isShow: true,
        },
        {
          title: '房间信息',
          dataIndex: 'hname',
          key: 'hname',
          isShow: true,
        },
        {
          title: '用户信息',
          dataIndex: 'user_id',
          key: 'user_id',
          isShow: true,
          width: 150,
          ellipsis: true,
        },
        {
          title: '是否已读',
          dataIndex: 'is_read_text',
          key: 'is_read_text',
          width: 80,
          isShow: true,
        },
        {
          title: '状态',
          dataIndex: 'status_text',
          key: 'status_text',
          width: 80,
          isShow: true,
        },
        {
          title: '意见',
          dataIndex: 'feedback',
          key: 'feedback',
          min_width: 200,
          isShow: true,
          ellipsis: true,
        },
        {
          title: '附件',
          dataIndex: 'images',
          key: 'images',
          min_width: 300,
          isShow: true,
        },
        {
          title: '解决方案',
          dataIndex: 'plan',
          key: 'plan',
          min_width: 200,
          isShow: true,
          ellipsis: true,
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          key: 'create_time',
          width: 150,
          isShow: true,
        },
        {
          title: '',
          dataIndex: 'operate',
          key: 'operate',
        },
      ];
    }

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    // 表格
    const table = reactive({
      currentItem: {},
      tableHeight: '',
      dataSource: [],
      topData: {},
      initColumns: [],
      getTableData() {
        search.searchLoading = true;
        feedBackList(search.searchForm)
          .then(res => {
            table.dataSource = res.data.list;
            pagination.pageTotal = res.data.count;
            nextTick(() => {
              table.columns = getColumns();
              table.initColumns = getColumns();
            });
            search.searchLoading = false;
          })
          .catch(() => {
            search.searchLoading = false;
          });
      },
      columns: [
        {
          title: '记录ID',
          dataIndex: 'id',
          key: 'id',
          isShow: true,
        },
        {
          title: '订单号',
          dataIndex: 'order_no',
          key: 'order_no',
          min_width: 150,
          isShow: true,
        },
        {
          title: '房间信息',
          dataIndex: 'hname',
          key: 'hname',
          isShow: true,
        },
        {
          title: '用户ID',
          dataIndex: 'user_id',
          key: 'user_id',
          isShow: true,
        },
        {
          title: '是否已读',
          dataIndex: 'is_read_text',
          key: 'is_read_text',
          width: 80,
          isShow: true,
        },
        {
          title: '状态',
          dataIndex: 'status_text',
          key: 'status_text',
          width: 80,
          isShow: true,
        },
        {
          title: '意见',
          dataIndex: 'feedback',
          key: 'feedback',
          min_width: 300,
          isShow: true,
          ellipsis: true,
        },
        {
          title: '附件',
          dataIndex: 'images',
          key: 'images',
          min_width: 300,
          isShow: true,
        },
        {
          title: '解决方案',
          dataIndex: 'plan',
          key: 'plan',
          min_width: 300,
          isShow: true,
          ellipsis: true,
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          key: 'create_time',
          width: 150,
          isShow: true,
        },
        {
          title: '',
          dataIndex: 'operate',
          key: 'operate',
        },
      ],
    });

    // 订单
    const order = reactive({
      detShow: false,
      orderId: '',
      refresh() {
        table.getTableData();
      },
    });
    // 订单
    const details = reactive({
      feedShow: false,
      id: '',
      refresh() {
        table.getTableData();
      },
    });

    watch(
      () => store.state.ContentHeight,
      () => {
        table.tableHeight = countTable(search.topDom) - 115;
      }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 115;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      ...toRefs(order),
      ...toRefs(details),
    };
  },
};
</script>

<style lang="scss" scoped>
.refund {
  .refund-switch {
    display: flex;
    align-items: center;
    cursor: pointer;

    .switch-lef {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 6px 0 0 6px;
      width: 100px;
      text-align: center;
    }

    .switch-rig {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 0 6px 6px 0;
      width: 100px;
      text-align: center;
    }

    .refundSel {
      background-color: #1890ff;
      color: #fff;
      border: none;
    }
  }
}

.head-box {
  margin-bottom: 10px;
  font-weight: bold;
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}

.image-preview-group {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-preview-group img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}
</style>
